import React from 'react';
import PropTypes from 'prop-types';

const RefreshLyric = (props) => {
  return (
    <i
      className="icon  icon-refresh  refresh-lyric"
      onClick={props.getRandomLyric}
    />
  );
};

RefreshLyric.propTypes = {
  getRandomLyric: PropTypes.func.isRequired,
};

export default RefreshLyric;



// WEBPACK FOOTER //
// ./src/components/RefreshLyric.js